import get from 'transmute/get';
export const getId = get('senderId');
export const getType = get('senderType');